export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Shallow check:
 * Ensures every enumerable own property in `source`
 * exists in `target` with the same value.
 */
export function shallowObjectMatch<
  T extends Record<PropertyKey, unknown>,
  U extends Record<PropertyKey, unknown>,
>(source: T, target: U, keysToCheck?: readonly (keyof T)[]): boolean {
  // check for null or undefined
  if (!source || !target) return false;

  if (keysToCheck?.length > 0) {
    return keysToCheck.every(
      (key) =>
        Object.prototype.propertyIsEnumerable.call(source, key) &&
        Object.prototype.propertyIsEnumerable.call(target, key) &&
        Object.is(source[key], target[key])
    );
  }

  return Object.keys(source).every(
    (key) => target.propertyIsEnumerable(key) && Object.is(source[key], target[key])
  );
}
